import { IconX } from "@tabler/icons-react";
import { Trans, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import { Button } from "../common/Button";
import { IconButton } from "../common/IconButton";
import styles from "./TutorialOverlay.module.css";

const skipLabel = msg`Пропустить обучение`;

interface CoachmarkBubbleProps {
  stepNumber?: number;
  total?: number;
  phaseLabel?: string;
  title: string;
  body: string;
  buttonLabel: string | null;
  style: React.CSSProperties;
  bubbleRef: React.Ref<HTMLDivElement>;
  onNext: () => void;
  onSkip?: () => void;
}

export function CoachmarkBubble({
  stepNumber,
  total,
  phaseLabel,
  title,
  body,
  buttonLabel,
  style,
  bubbleRef,
  onNext,
  onSkip,
}: CoachmarkBubbleProps): JSX.Element {
  const { i18n } = useLingui();

  return (
    <div
      ref={bubbleRef}
      className={styles.bubble}
      style={style}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      {stepNumber !== undefined && total !== undefined && (
        <div className={styles.bubbleHead}>
          <span className={styles.bubbleStep}>
            <Trans>
              Шаг {stepNumber} из {total}
            </Trans>
            {phaseLabel ? ` · ${phaseLabel}` : null}
          </span>
          {onSkip && (
            <IconButton label={i18n._(skipLabel)} icon={<IconX size={16} />} onClick={onSkip} />
          )}
        </div>
      )}
      <h3 className={styles.bubbleTitle}>{title}</h3>
      <p className={styles.bubbleBody}>{body}</p>
      <div className={styles.bubbleActions}>
        {onSkip && (
          <Button variant="ghost" size="small" onClick={onSkip}>
            <Trans>Пропустить обучение</Trans>
          </Button>
        )}
        {buttonLabel ? (
          <Button variant="primary" size="small" onClick={onNext}>
            {buttonLabel}
          </Button>
        ) : (
          <span className={styles.waitHint}>
            <Trans>Сделай действие, чтобы продолжить</Trans>
          </span>
        )}
      </div>
    </div>
  );
}
